import React from 'react'
import {
    MDBContainer,
    MDBIcon,
    MDBListGroupItem,
    MDBListGroup,
    MDBBadge,
    MDBCol,
    MDBRow,
    MDBBtn,
  } from "mdbreact";
  import { Link } from "react-router-dom";
import "../App.css";
import  LentForm  from "./LentForm";
function IndividualBook({item, modal, toggle}) {
    return (
        <div>
            <MDBListGroup style={{ width: "100%" }}>
                    <MDBListGroupItem
                      className="d-flex justify-content-between align-items-center mt-10 listitems "
                      style={{ marginTop: "20px" }}
                      color={item.data().read === "true" ? "default" : "danger"}
                    >
                      {" "}
                      <Link
                        to={{ pathname: `details/${item.id}` }}
                        style={{ color: "black" }}
                      >
                        {" "}
                        <MDBIcon icon="book-open" className="icon" />
                        <b> {item.data().name}</b>
                      </Link>{" "}
                      {item.data().lent === "true" ? (
                        <MDBBadge color="green" pill>
                          Lent
                        </MDBBadge>
                      ) : (
                        <div>
                          <MDBBadge color="red" pill onClick={toggle}>
                            Lend to
                          </MDBBadge>
                          {modal ? <LentForm modal={modal} toggle={toggle} bookId={item.id}/> : null}
                        </div>
                      )}
                    </MDBListGroupItem>
                  </MDBListGroup>
            
        </div>
    )
}

export default IndividualBook
